// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"FM-z","carouselContainer":"GM-z"};